import { useReactiveVar } from '@apollo/client';
import { usePathname } from 'next/navigation';
import { FC, memo, ReactElement, useMemo } from 'react';

// import { useParams, useSearchParams } from 'next/navigation';
import { CustomButtonLink } from '@/components/CustomButton';
import { headerLinksData, headerLinksSubMenuData } from '@/services/apollo/vars';

import SubMenuPopover from './SubMenuPopover';
import { TLinks } from './SubMenuPopover/SubMenuPopoverContent';

const Links: FC = (): ReactElement => {
	const pathname = usePathname();
	const selectedPathName = usePathname()?.split('/')?.[1].toLowerCase() ?? '';
	const navLinks = useReactiveVar(headerLinksData);
	const memoizedNavLinks = useMemo(() => navLinks, [navLinks]);
	return (
		<nav className="relative flex h-full space-x-2 xl:space-x-4">
			{memoizedNavLinks &&
				memoizedNavLinks?.map(({ displayName = '', link, dynamic, subMenu = [] }) => {
					if (subMenu.length > 0 || dynamic)
						return (
							<SubMenuPopover
								dynamic={dynamic}
								key={displayName}
								isActive={false}
								title={displayName}
								links={subMenu as unknown as TLinks[]}
								loading={false}
								className="sub-menu font-semibold"
							/>
						);

					if (link) {
						const active = (() => {
							if (typeof link !== 'string' || link.includes('https')) {
								return false;
							}

							const pathSegments = link.split('/');
							const firstSegment = pathSegments[1];
							const checkSelectedPathNameList = ['networks', 'providers', 'dvrf', 'indices', 'validators'];

							if (
								pathname.includes(selectedPathName) &&
								displayName === 'DATA' &&
								!checkSelectedPathNameList.includes(selectedPathName)
							) {
								return true;
							}

							if (firstSegment === '' && ['', 'forex', 'details'].includes(selectedPathName)) {
								return displayName === 'DATA';
							}

							if (selectedPathName) {
								return selectedPathName === firstSegment || link.includes(selectedPathName);
							}
							return displayName === 'DATA';
						})();

						return (
							<div key={displayName} className="nav-item group relative flex items-center">
								{link === 'https://docs.supra.com/oracles/data-feeds' ? (
									<CustomButtonLink
										href={link}
										target="_blank"
										className="flex !h-auto min-h-min items-center rounded-lg p-2 !text-gray outline-none transition duration-150 ease-in-out hover:!text-midnight dark:!text-header-gray dark:hover:!text-white">
										<p
											className={`font-medium normal-case after:absolute after:bottom-[-17px] after:left-0 after:h-0.5 after:w-full after:bg-[linear-gradient(162deg,#DD1438_0%,#5B01A2_100%)] after:opacity-0 group-hover:after:opacity-100 ${
												active
													? 'flex h-full items-center space-x-2 rounded-md text-sm text-midnight after:opacity-100 focus:outline-none group-hover:text-midnight dark:text-white dark:group-hover:text-white'
													: 'text-sm !text-inherit text-header-gray'
											}`}>
											{displayName}
										</p>
									</CustomButtonLink>
								) : (
									<CustomButtonLink
										useNextLink
										href={link}
										target="_self"
										className="flex !h-auto min-h-min items-center rounded-lg p-2 !text-gray outline-none transition duration-150 ease-in-out hover:!text-midnight dark:!text-header-gray dark:hover:!text-white">
										<p
											className={`font-medium normal-case after:absolute after:bottom-[-17px] after:left-0 after:h-0.5 after:w-full after:bg-[linear-gradient(162deg,#DD1438_0%,#5B01A2_100%)] after:opacity-0 group-hover:after:opacity-100 ${
												active
													? 'flex h-full items-center space-x-2 rounded-md text-sm text-midnight after:opacity-100 focus:outline-none group-hover:text-midnight dark:text-white dark:group-hover:text-white'
													: 'text-sm !text-inherit text-header-gray'
											}`}>
											{displayName}
										</p>
									</CustomButtonLink>
								)}
							</div>
						);
					}
				})}
		</nav>
	);
};

export default memo(Links);
